import { ThumbnailContent } from "../../../components/Content/ThumbnailContent.tsx";
import { IMAGE_RESOURCE_TYPE } from "../../Board/constants.ts";
import { useModel } from "../hooks/useModel.ts";

export const ModelPreview = () => {
  const { model } = useModel();
  return (
    model.contents.length >= 3 && (
      <div className="relative h-[168px] w-[168px] aspect-square">
        <div
          className="absolute h-[75%] aspect-square shadow-200 rounded-300"
          style={{ transform: "translateX(-105px) translateY(21px)" }}
        >
          <ThumbnailContent
            resourceType={IMAGE_RESOURCE_TYPE}
            src={model.contents[1].url}
            className="w-full h-full rounded-300 overflow-hidden"
          />
        </div>
        <div
          className="absolute h-[75%] aspect-square shadow-200 rounded-300"
          style={{ transform: "translateX(147px) translateY(21px)" }}
        >
          <ThumbnailContent
            resourceType={IMAGE_RESOURCE_TYPE}
            src={model.contents[2].url}
            className="w-full h-full rounded-300 overflow-hidden"
          />
        </div>
        <ThumbnailContent
          resourceType={IMAGE_RESOURCE_TYPE}
          src={model.contents[0].url}
          className="w-full h-full absolute ring-8 ring-white shadow-400 rounded-300 overflow-hidden"
        />
      </div>
    )
  );
};
